import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _a953e9ac = () => interopDefault(import('../pages/about-us.vue' /* webpackChunkName: "pages/about-us" */))
const _c3d06654 = () => interopDefault(import('../pages/case-studies.vue' /* webpackChunkName: "pages/case-studies" */))
const _1a4c7584 = () => interopDefault(import('../pages/contact.vue' /* webpackChunkName: "pages/contact" */))
const _1ba28f9f = () => interopDefault(import('../pages/cookie-policy.vue' /* webpackChunkName: "pages/cookie-policy" */))
const _d69fd794 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _04439f9a = () => interopDefault(import('../pages/filipino-workforce.vue' /* webpackChunkName: "pages/filipino-workforce" */))
const _75759d0a = () => interopDefault(import('../pages/indian-dentists.vue' /* webpackChunkName: "pages/indian-dentists" */))
const _18601d90 = () => interopDefault(import('../pages/indian-workforce.vue' /* webpackChunkName: "pages/indian-workforce" */))
const _31468cc4 = () => interopDefault(import('../pages/job-seeker/index.vue' /* webpackChunkName: "pages/job-seeker/index" */))
const _4a00d83c = () => interopDefault(import('../pages/news/index.vue' /* webpackChunkName: "pages/news/index" */))
const _429b05e3 = () => interopDefault(import('../pages/privacy-policy.vue' /* webpackChunkName: "pages/privacy-policy" */))
const _078ee2ac = () => interopDefault(import('../pages/services.vue' /* webpackChunkName: "pages/services" */))
const _594eaa79 = () => interopDefault(import('../pages/job-seeker/advice/index.vue' /* webpackChunkName: "pages/job-seeker/advice/index" */))
const _29b1fadc = () => interopDefault(import('../pages/job-seeker/contact.vue' /* webpackChunkName: "pages/job-seeker/contact" */))
const _e7ce6452 = () => interopDefault(import('../pages/job-seeker/jobs/index.vue' /* webpackChunkName: "pages/job-seeker/jobs/index" */))
const _598cadc0 = () => interopDefault(import('../pages/job-seeker/advice/preview/_advice_preview.vue' /* webpackChunkName: "pages/job-seeker/advice/preview/_advice_preview" */))
const _747962f9 = () => interopDefault(import('../pages/job-seeker/jobs/preview/_job_preview.vue' /* webpackChunkName: "pages/job-seeker/jobs/preview/_job_preview" */))
const _2d7c097e = () => interopDefault(import('../pages/job-seeker/advice/_advice.vue' /* webpackChunkName: "pages/job-seeker/advice/_advice" */))
const _1bd48189 = () => interopDefault(import('../pages/job-seeker/jobs/_job.vue' /* webpackChunkName: "pages/job-seeker/jobs/_job" */))
const _2a6eb147 = () => interopDefault(import('../pages/news/preview/_article_preview.vue' /* webpackChunkName: "pages/news/preview/_article_preview" */))
const _0ec2ee57 = () => interopDefault(import('../pages/news/_article.vue' /* webpackChunkName: "pages/news/_article" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about-us",
    component: _a953e9ac,
    name: "about-us___en___default"
  }, {
    path: "/case-studies",
    component: _c3d06654,
    name: "case-studies___en___default"
  }, {
    path: "/contact",
    component: _1a4c7584,
    name: "contact___en___default"
  }, {
    path: "/cookie-policy",
    component: _1ba28f9f,
    name: "cookie-policy___en___default"
  }, {
    path: "/de",
    component: _d69fd794,
    name: "index___de"
  }, {
    path: "/en",
    component: _d69fd794,
    name: "index___en"
  }, {
    path: "/filipino-workforce",
    component: _04439f9a,
    name: "filipino-workforce___en___default"
  }, {
    path: "/hu",
    component: _d69fd794,
    name: "index___hu"
  }, {
    path: "/indian-dentists",
    component: _75759d0a,
    name: "indian-dentists___en___default"
  }, {
    path: "/indian-workforce",
    component: _18601d90,
    name: "indian-workforce___en___default"
  }, {
    path: "/job-seeker",
    component: _31468cc4,
    name: "job-seeker___en___default"
  }, {
    path: "/ko",
    component: _d69fd794,
    name: "index___ko"
  }, {
    path: "/news",
    component: _4a00d83c,
    name: "news___en___default"
  }, {
    path: "/privacy-policy",
    component: _429b05e3,
    name: "privacy-policy___en___default"
  }, {
    path: "/services",
    component: _078ee2ac,
    name: "services___en___default"
  }, {
    path: "/zh",
    component: _d69fd794,
    name: "index___zh"
  }, {
    path: "/de/about-us",
    component: _a953e9ac,
    name: "about-us___de"
  }, {
    path: "/de/case-studies",
    component: _c3d06654,
    name: "case-studies___de"
  }, {
    path: "/de/contact",
    component: _1a4c7584,
    name: "contact___de"
  }, {
    path: "/de/cookie-policy",
    component: _1ba28f9f,
    name: "cookie-policy___de"
  }, {
    path: "/de/filipino-workforce",
    component: _04439f9a,
    name: "filipino-workforce___de"
  }, {
    path: "/de/indian-dentists",
    component: _75759d0a,
    name: "indian-dentists___de"
  }, {
    path: "/de/indian-workforce",
    component: _18601d90,
    name: "indian-workforce___de"
  }, {
    path: "/de/job-seeker",
    component: _31468cc4,
    name: "job-seeker___de"
  }, {
    path: "/de/news",
    component: _4a00d83c,
    name: "news___de"
  }, {
    path: "/de/privacy-policy",
    component: _429b05e3,
    name: "privacy-policy___de"
  }, {
    path: "/de/services",
    component: _078ee2ac,
    name: "services___de"
  }, {
    path: "/en/about-us",
    component: _a953e9ac,
    name: "about-us___en"
  }, {
    path: "/en/case-studies",
    component: _c3d06654,
    name: "case-studies___en"
  }, {
    path: "/en/contact",
    component: _1a4c7584,
    name: "contact___en"
  }, {
    path: "/en/cookie-policy",
    component: _1ba28f9f,
    name: "cookie-policy___en"
  }, {
    path: "/en/filipino-workforce",
    component: _04439f9a,
    name: "filipino-workforce___en"
  }, {
    path: "/en/indian-dentists",
    component: _75759d0a,
    name: "indian-dentists___en"
  }, {
    path: "/en/indian-workforce",
    component: _18601d90,
    name: "indian-workforce___en"
  }, {
    path: "/en/job-seeker",
    component: _31468cc4,
    name: "job-seeker___en"
  }, {
    path: "/en/news",
    component: _4a00d83c,
    name: "news___en"
  }, {
    path: "/en/privacy-policy",
    component: _429b05e3,
    name: "privacy-policy___en"
  }, {
    path: "/en/services",
    component: _078ee2ac,
    name: "services___en"
  }, {
    path: "/hu/about-us",
    component: _a953e9ac,
    name: "about-us___hu"
  }, {
    path: "/hu/case-studies",
    component: _c3d06654,
    name: "case-studies___hu"
  }, {
    path: "/hu/contact",
    component: _1a4c7584,
    name: "contact___hu"
  }, {
    path: "/hu/cookie-policy",
    component: _1ba28f9f,
    name: "cookie-policy___hu"
  }, {
    path: "/hu/filipino-workforce",
    component: _04439f9a,
    name: "filipino-workforce___hu"
  }, {
    path: "/hu/indian-dentists",
    component: _75759d0a,
    name: "indian-dentists___hu"
  }, {
    path: "/hu/indian-workforce",
    component: _18601d90,
    name: "indian-workforce___hu"
  }, {
    path: "/hu/job-seeker",
    component: _31468cc4,
    name: "job-seeker___hu"
  }, {
    path: "/hu/news",
    component: _4a00d83c,
    name: "news___hu"
  }, {
    path: "/hu/privacy-policy",
    component: _429b05e3,
    name: "privacy-policy___hu"
  }, {
    path: "/hu/services",
    component: _078ee2ac,
    name: "services___hu"
  }, {
    path: "/job-seeker/advice",
    component: _594eaa79,
    name: "job-seeker-advice___en___default"
  }, {
    path: "/job-seeker/contact",
    component: _29b1fadc,
    name: "job-seeker-contact___en___default"
  }, {
    path: "/job-seeker/jobs",
    component: _e7ce6452,
    name: "job-seeker-jobs___en___default"
  }, {
    path: "/ko/about-us",
    component: _a953e9ac,
    name: "about-us___ko"
  }, {
    path: "/ko/case-studies",
    component: _c3d06654,
    name: "case-studies___ko"
  }, {
    path: "/ko/contact",
    component: _1a4c7584,
    name: "contact___ko"
  }, {
    path: "/ko/cookie-policy",
    component: _1ba28f9f,
    name: "cookie-policy___ko"
  }, {
    path: "/ko/filipino-workforce",
    component: _04439f9a,
    name: "filipino-workforce___ko"
  }, {
    path: "/ko/indian-dentists",
    component: _75759d0a,
    name: "indian-dentists___ko"
  }, {
    path: "/ko/indian-workforce",
    component: _18601d90,
    name: "indian-workforce___ko"
  }, {
    path: "/ko/job-seeker",
    component: _31468cc4,
    name: "job-seeker___ko"
  }, {
    path: "/ko/news",
    component: _4a00d83c,
    name: "news___ko"
  }, {
    path: "/ko/privacy-policy",
    component: _429b05e3,
    name: "privacy-policy___ko"
  }, {
    path: "/ko/services",
    component: _078ee2ac,
    name: "services___ko"
  }, {
    path: "/zh/about-us",
    component: _a953e9ac,
    name: "about-us___zh"
  }, {
    path: "/zh/case-studies",
    component: _c3d06654,
    name: "case-studies___zh"
  }, {
    path: "/zh/contact",
    component: _1a4c7584,
    name: "contact___zh"
  }, {
    path: "/zh/cookie-policy",
    component: _1ba28f9f,
    name: "cookie-policy___zh"
  }, {
    path: "/zh/filipino-workforce",
    component: _04439f9a,
    name: "filipino-workforce___zh"
  }, {
    path: "/zh/indian-dentists",
    component: _75759d0a,
    name: "indian-dentists___zh"
  }, {
    path: "/zh/indian-workforce",
    component: _18601d90,
    name: "indian-workforce___zh"
  }, {
    path: "/zh/job-seeker",
    component: _31468cc4,
    name: "job-seeker___zh"
  }, {
    path: "/zh/news",
    component: _4a00d83c,
    name: "news___zh"
  }, {
    path: "/zh/privacy-policy",
    component: _429b05e3,
    name: "privacy-policy___zh"
  }, {
    path: "/zh/services",
    component: _078ee2ac,
    name: "services___zh"
  }, {
    path: "/de/job-seeker/advice",
    component: _594eaa79,
    name: "job-seeker-advice___de"
  }, {
    path: "/de/job-seeker/contact",
    component: _29b1fadc,
    name: "job-seeker-contact___de"
  }, {
    path: "/de/job-seeker/jobs",
    component: _e7ce6452,
    name: "job-seeker-jobs___de"
  }, {
    path: "/en/job-seeker/advice",
    component: _594eaa79,
    name: "job-seeker-advice___en"
  }, {
    path: "/en/job-seeker/contact",
    component: _29b1fadc,
    name: "job-seeker-contact___en"
  }, {
    path: "/en/job-seeker/jobs",
    component: _e7ce6452,
    name: "job-seeker-jobs___en"
  }, {
    path: "/hu/job-seeker/advice",
    component: _594eaa79,
    name: "job-seeker-advice___hu"
  }, {
    path: "/hu/job-seeker/contact",
    component: _29b1fadc,
    name: "job-seeker-contact___hu"
  }, {
    path: "/hu/job-seeker/jobs",
    component: _e7ce6452,
    name: "job-seeker-jobs___hu"
  }, {
    path: "/ko/job-seeker/advice",
    component: _594eaa79,
    name: "job-seeker-advice___ko"
  }, {
    path: "/ko/job-seeker/contact",
    component: _29b1fadc,
    name: "job-seeker-contact___ko"
  }, {
    path: "/ko/job-seeker/jobs",
    component: _e7ce6452,
    name: "job-seeker-jobs___ko"
  }, {
    path: "/zh/job-seeker/advice",
    component: _594eaa79,
    name: "job-seeker-advice___zh"
  }, {
    path: "/zh/job-seeker/contact",
    component: _29b1fadc,
    name: "job-seeker-contact___zh"
  }, {
    path: "/zh/job-seeker/jobs",
    component: _e7ce6452,
    name: "job-seeker-jobs___zh"
  }, {
    path: "/",
    component: _d69fd794,
    name: "index___en___default"
  }, {
    path: "/de/job-seeker/advice/preview/:advice_preview",
    component: _598cadc0,
    name: "job-seeker-advice-preview-advice_preview___de"
  }, {
    path: "/de/job-seeker/jobs/preview/:job_preview",
    component: _747962f9,
    name: "job-seeker-jobs-preview-job_preview___de"
  }, {
    path: "/en/job-seeker/advice/preview/:advice_preview",
    component: _598cadc0,
    name: "job-seeker-advice-preview-advice_preview___en"
  }, {
    path: "/en/job-seeker/jobs/preview/:job_preview",
    component: _747962f9,
    name: "job-seeker-jobs-preview-job_preview___en"
  }, {
    path: "/hu/job-seeker/advice/preview/:advice_preview",
    component: _598cadc0,
    name: "job-seeker-advice-preview-advice_preview___hu"
  }, {
    path: "/hu/job-seeker/jobs/preview/:job_preview",
    component: _747962f9,
    name: "job-seeker-jobs-preview-job_preview___hu"
  }, {
    path: "/ko/job-seeker/advice/preview/:advice_preview",
    component: _598cadc0,
    name: "job-seeker-advice-preview-advice_preview___ko"
  }, {
    path: "/ko/job-seeker/jobs/preview/:job_preview",
    component: _747962f9,
    name: "job-seeker-jobs-preview-job_preview___ko"
  }, {
    path: "/zh/job-seeker/advice/preview/:advice_preview",
    component: _598cadc0,
    name: "job-seeker-advice-preview-advice_preview___zh"
  }, {
    path: "/zh/job-seeker/jobs/preview/:job_preview",
    component: _747962f9,
    name: "job-seeker-jobs-preview-job_preview___zh"
  }, {
    path: "/de/job-seeker/advice/:advice",
    component: _2d7c097e,
    name: "job-seeker-advice-advice___de"
  }, {
    path: "/de/job-seeker/jobs/:job",
    component: _1bd48189,
    name: "job-seeker-jobs-job___de"
  }, {
    path: "/de/news/preview/:article_preview?",
    component: _2a6eb147,
    name: "news-preview-article_preview___de"
  }, {
    path: "/en/job-seeker/advice/:advice",
    component: _2d7c097e,
    name: "job-seeker-advice-advice___en"
  }, {
    path: "/en/job-seeker/jobs/:job",
    component: _1bd48189,
    name: "job-seeker-jobs-job___en"
  }, {
    path: "/en/news/preview/:article_preview?",
    component: _2a6eb147,
    name: "news-preview-article_preview___en"
  }, {
    path: "/hu/job-seeker/advice/:advice",
    component: _2d7c097e,
    name: "job-seeker-advice-advice___hu"
  }, {
    path: "/hu/job-seeker/jobs/:job",
    component: _1bd48189,
    name: "job-seeker-jobs-job___hu"
  }, {
    path: "/hu/news/preview/:article_preview?",
    component: _2a6eb147,
    name: "news-preview-article_preview___hu"
  }, {
    path: "/job-seeker/advice/preview/:advice_preview",
    component: _598cadc0,
    name: "job-seeker-advice-preview-advice_preview___en___default"
  }, {
    path: "/job-seeker/jobs/preview/:job_preview",
    component: _747962f9,
    name: "job-seeker-jobs-preview-job_preview___en___default"
  }, {
    path: "/ko/job-seeker/advice/:advice",
    component: _2d7c097e,
    name: "job-seeker-advice-advice___ko"
  }, {
    path: "/ko/job-seeker/jobs/:job",
    component: _1bd48189,
    name: "job-seeker-jobs-job___ko"
  }, {
    path: "/ko/news/preview/:article_preview?",
    component: _2a6eb147,
    name: "news-preview-article_preview___ko"
  }, {
    path: "/zh/job-seeker/advice/:advice",
    component: _2d7c097e,
    name: "job-seeker-advice-advice___zh"
  }, {
    path: "/zh/job-seeker/jobs/:job",
    component: _1bd48189,
    name: "job-seeker-jobs-job___zh"
  }, {
    path: "/zh/news/preview/:article_preview?",
    component: _2a6eb147,
    name: "news-preview-article_preview___zh"
  }, {
    path: "/de/news/:article",
    component: _0ec2ee57,
    name: "news-article___de"
  }, {
    path: "/en/news/:article",
    component: _0ec2ee57,
    name: "news-article___en"
  }, {
    path: "/hu/news/:article",
    component: _0ec2ee57,
    name: "news-article___hu"
  }, {
    path: "/job-seeker/advice/:advice",
    component: _2d7c097e,
    name: "job-seeker-advice-advice___en___default"
  }, {
    path: "/job-seeker/jobs/:job",
    component: _1bd48189,
    name: "job-seeker-jobs-job___en___default"
  }, {
    path: "/ko/news/:article",
    component: _0ec2ee57,
    name: "news-article___ko"
  }, {
    path: "/news/preview/:article_preview?",
    component: _2a6eb147,
    name: "news-preview-article_preview___en___default"
  }, {
    path: "/zh/news/:article",
    component: _0ec2ee57,
    name: "news-article___zh"
  }, {
    path: "/news/:article",
    component: _0ec2ee57,
    name: "news-article___en___default"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
